export default __webpack_public_path__ + "static/media/Binusha.c949d999.jpg";